import React from 'react'

const About = () => {
  return (
    <div className="container mx-auto py-8">
    <h1 className="text-3xl font-semibold mb-4">About Us</h1>
    <p className="text-lg">
      Welcome cuet based book sharing website! Here you can share your unnecessary book and borrow  necessary  book from other user .
    </p>
    <p className="text-lg mt-4">
      Our goal is to sharing book in cuet campus . If you share book our website can offer a wide range of
      book from various categories, including eee,cse,me and more.By sharing book help others to enriched knowladge.
    </p>
  </div>
  )
}

export default About
